import { metrics } from '@opentelemetry/api';
import { onCLS, onFCP, onFID, onLCP, onTTFB } from 'web-vitals';
const initWebVitalsMonitoring = () => {
    const meter = metrics.getMeter('web-vitals', process.env.VERSION);
    const lcp = meter.createHistogram('lcp', {
        description: 'Largest Contentful Paint',
        unit: 'ms',
    });
    const cls = meter.createObservableGauge('cls', {
        description: 'Content Layout Shift'
    });
    const fid = meter.createHistogram('fid', {
        description: 'First Input Delay',
        unit: 'ms',
    });
    const ttfb = meter.createHistogram('ttfb', {
        description: 'Time To First Byte',
        unit: 'ms',
    });
    const fcp = meter.createHistogram('fcp', {
        description: 'First Contentful Paint',
        unit: 'ms',
    });
    const sendToAnalytics = (metric) => {
        if (Math.random() > 0.5) {
            return;
        }
        switch (metric.name) {
            case 'LCP': {
                lcp.record(metric.value);
                break;
            }
            case 'CLS': {
                cls.addCallback((result) => {
                    result.observe(metric.value);
                });
                break;
            }
            case 'FID': {
                fid.record(metric.value);
                break;
            }
            case 'TTFB': {
                ttfb.record(metric.value);
                break;
            }
            case 'FCP': {
                fcp.record(metric.value);
                break;
            }
            default: {
                console.info('Unexpected metric name');
            }
        }
    };
    onLCP(sendToAnalytics);
    onCLS(sendToAnalytics);
    onFID(sendToAnalytics);
    onTTFB(sendToAnalytics);
    onFCP(sendToAnalytics);
    console.info('Web Vitals monitoring initialized');
};
export { initWebVitalsMonitoring };
